import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "ai-dict" }
const _hoisted_2 = {
  key: 1,
  class: "ai-dict-pill"
}
const _hoisted_3 = { class: "ai-dict-wave" }
const _hoisted_4 = ["title"]
const _hoisted_5 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "15",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}
const _hoisted_6 = {
  key: 1,
  class: "ai-dict-spin"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.state)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "ai-dict-mic",
          title: "Dictate instead of typing",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.start()))
        }, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "17",
            height: "17",
            viewBox: "0 0 24 24",
            fill: "currentColor"
          }, [
            _createElementVNode("path", { d: "M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.91-3c-.49 0-.9.36-.98.85C16.52 14.2 14.47 16 12 16s-4.52-1.8-4.93-4.15c-.08-.49-.49-.85-.98-.85-.61 0-1.09.54-1 1.14.49 3 2.89 5.35 5.91 5.78V20c0 .55.45 1 1 1s1-.45 1-1v-2.08c3.02-.43 5.42-2.78 5.91-5.78.1-.6-.39-1.14-1-1.14z" })
          ], -1)
        ]))]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "ai-dict-btn ai-dict-cancel",
            title: "Cancel",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cancel()))
          }, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "15",
              height: "15",
              viewBox: "0 0 24 24",
              fill: "currentColor"
            }, [
              _createElementVNode("path", { d: "M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z" })
            ], -1)
          ]))]),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(9, (n) => {
              return _createElementVNode("span", {
                key: n,
                style: _normalizeStyle({ animationDelay: (n * 0.11) + 's' }),
                class: _normalizeClass(_ctx.state == 'converting' ? 'ai-dict-bar-idle' : '')
              }, null, 6)
            }), 64))
          ]),
          _createElementVNode("div", {
            class: "ai-dict-btn ai-dict-ok",
            title: _ctx.state == 'converting' ? 'Converting...' : 'Stop and convert to text',
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.convert()))
          }, [
            (_ctx.state == 'recording')
              ? (_openBlock(), _createElementBlock("svg", _hoisted_5, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("path", { d: "M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z" }, null, -1)
                ]))]))
              : (_openBlock(), _createElementBlock("span", _hoisted_6))
          ], 8, _hoisted_4)
        ]))
  ]))
}